'use strict';

module.exports = getDocumentProtocol;

function getDocumentProtocol() {
  var protocol = window.document.location.protocol;

  // when in `file:` mode (local html file), default to `http:`
  if (protocol !== 'http:' && protocol !== 'https:') {
    protocol = 'http:';
  }

  return protocol;
}



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/browser/get-document-protocol.js
// module id = 36
// module chunks = 0